// Generated by purs version 0.13.8
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Component_WithLogo = require("../Lunarbox.Component.WithLogo/index.js");
var formPage = function (v) {
    return Lunarbox_Component_Utils.container("form-page")([ Lunarbox_Component_WithLogo.withLogo(Lunarbox_Component_Utils.container("form-container")([ Lunarbox_Component_Utils.container("title-row")([ Lunarbox_Component_Utils.container("title")([ Halogen_HTML_Core.text(v.title) ]), Lunarbox_Component_Utils.container("message")([ Lunarbox_Component_Utils.container("message-normal")([ Halogen_HTML_Core.text(v.message) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id_("message-action"), Halogen_HTML_Events.onClick(Data_Function["const"](v.onAction)) ])([ Halogen_HTML_Core.text(v.action) ]) ]) ]), v.content ])) ]);
};
module.exports = {
    formPage: formPage
};
